export default [
  {
    path: '/test',
    component: () => import('@/layouts/main.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'Dashboardtest',
        name: 'Dashboardtest',
        component: () => import('@/views/dashboard/index.vue'),
        meta: {
          icon: 'home',
          title: '首页',
          affix: true,
          auth: true,
          notAuthPage: true,
        },
      },
    ],
  },
];
